import { render, staticRenderFns } from "./ClinicPage.vue?vue&type=template&id=025837b9"
import script from "./ClinicPage.vue?vue&type=script&lang=js"
export * from "./ClinicPage.vue?vue&type=script&lang=js"
import style0 from "./ClinicPage.vue?vue&type=style&index=0&id=025837b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports